import '../objects/product/ProductThumbnail';

const articleContentVideo = class extends HTMLElement {
  video: HTMLVideoElement;
  playButton: HTMLElement;

  constructor() {
    super();

    this.video = this.querySelector('[data-video]');
    this.playButton = this.querySelector('[data-article-content-play]');

    this.initVideo();
  }

  /**
   * Play video
   */
  initVideo() {
    this.playButton.addEventListener('click', () => {
      this.playButton.classList.add('hidden');
      this.video.play();
    });
  }
};

if (typeof window.customElements.get('article-content-video') === 'undefined') {
  window.customElements.define('article-content-video', articleContentVideo);
}
